/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Oracle_Vault, Oracle_VaultInterface } from "../Oracle_Vault";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wNat",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_unlockUntil",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "CSM",
    outputs: [
      {
        internalType: "contract IClaimSetupManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NFTContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "activeAutoClaim",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "currentDelegatees",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "delegatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[2]",
        name: "delegatee",
        type: "address[2]",
      },
    ],
    name: "delegateTo",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositETH",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "executors",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoManager",
    outputs: [
      {
        internalType: "contract IFtsoManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoRewardManager",
    outputs: [
      {
        internalType: "contract IFtsoRewardManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "gasReducer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getClaimableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFeeForExecutors",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getTokenInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "claimedAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "remainPerNFT",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct Oracle_Vault.Token",
        name: "tokenInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokenList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256",
      },
    ],
    name: "getWorthOfNFT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "removeToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_claimManager",
        type: "address",
      },
    ],
    name: "setClaimSetupManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_executors",
        type: "address[]",
      },
    ],
    name: "setExecutors",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ftsoManager",
        type: "address",
      },
    ],
    name: "setFtsoManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ftsoRewardManager",
        type: "address",
      },
    ],
    name: "setFtsoRewardManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_intervalEpochs",
        type: "uint256",
      },
    ],
    name: "setIntervalEpochs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_num",
        type: "uint256",
      },
    ],
    name: "setMaxDelegatableNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256",
      },
    ],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContract",
        type: "address",
      },
    ],
    name: "setNFTContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "string",
        name: "_tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lockedUntil",
        type: "uint256",
      },
    ],
    name: "setTokenERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVote4Delegation",
        name: "_votingContract",
        type: "address",
      },
    ],
    name: "setVotingContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wNat",
        type: "address",
      },
      {
        internalType: "string",
        name: "_tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lockedUntil",
        type: "uint256",
      },
    ],
    name: "setWNat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenList",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "claimedAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "unlockTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wNat",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_wrap",
        type: "bool",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAllTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "withdrawERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type Oracle_VaultConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Oracle_VaultConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Oracle_Vault__factory extends ContractFactory {
  constructor(...args: Oracle_VaultConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _wNat: PromiseOrValue<string>,
    _remainPerNFT: PromiseOrValue<BigNumberish>,
    _unlockUntil: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Oracle_Vault> {
    return super.deploy(
      _wNat,
      _remainPerNFT,
      _unlockUntil,
      overrides || {}
    ) as Promise<Oracle_Vault>;
  }
  override getDeployTransaction(
    _wNat: PromiseOrValue<string>,
    _remainPerNFT: PromiseOrValue<BigNumberish>,
    _unlockUntil: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _wNat,
      _remainPerNFT,
      _unlockUntil,
      overrides || {}
    );
  }
  override attach(address: string): Oracle_Vault {
    return super.attach(address) as Oracle_Vault;
  }
  override connect(signer: Signer): Oracle_Vault__factory {
    return super.connect(signer) as Oracle_Vault__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Oracle_VaultInterface {
    return new utils.Interface(_abi) as Oracle_VaultInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Oracle_Vault {
    return new Contract(address, _abi, signerOrProvider) as Oracle_Vault;
  }
}
